import { connect } from 'react-redux'
import { state_update } from '../actions'
import AiOptionSet from './AiOptionSet'
import {DEFAULT_STATE_VALUE} from '../constants';
import {param2sku} from '../logic/sku-ver3.js'

const mapStateToProps = (state, ownProps) => ({
  options: getOptions(state),
  ds:state.ds === DEFAULT_STATE_VALUE ?'R':state.ds,
  bandS:band(state,'S'),
  bandC:band(state,'C'),
  dctw:state.dctw === DEFAULT_STATE_VALUE ?'0.25':state.dctw,
  head:state.head,
  title:state.title,
  site:state.currentSite,
  showBandOptions:state.band === '0' ? 'ai-hide' : 'ai-show',
  sh:state.sh === DEFAULT_STATE_VALUE ?'1':state.sh,
  optionSize: ownProps.optionSize === 'big' ? 120: 100,
  single_sc_option: (state['options_all'].indexOf('sc') !== -1 && state['sc'] === DEFAULT_STATE_VALUE) ? true : false,
  options_all: state['options_all'].join('-')
  
  
})

function getOptions (state) 
{
  var res={};
  var all_options=state['options_all'];
  res['options_all'] = all_options;
  for (var i in all_options)
    {
      res['options_' + all_options[i]]= state['options_' + all_options[i]]
      res['value_' + all_options[i]]= state[all_options[i]]
    }

  //console.log('getOptions',res);  
  return res;  
}
function band (state,typeIn) 
{
   //console.log('STraing',typeIn)
  var newsku=param2sku(
    /*['0',state['ds'],state['ce'],state['dctw'],state['cec'],
    state['headc'],state['dq'],state['head'],state['sh'],state['pkb'],
    state['pkbc'],state['rset'],state['rsetl'],    state['rsetc'],state['ren'],
    state['rmet'],state['hmetc'],state['smetc'],state['renl'],state['rs'],
    '1',state['store'],typeIn,state['rset'],    state['rsetc'],
    state['rsetl'],state['rmet'],state['smetc'],state['rs'],state['ren'],
    state['renl'],'1','1'
    ])*/
      ['0',state['ds'],state['dctw'],state['dq'],state['sh'],state['head'],state['ren'],
      state['rmet'],state['rmetc'],state['rs'],
      state['store'],'S',state['ren'],state['rmet'],state['rmetc'],state['hmetc'],'D'
      
      ])
  //console.log ('bandsku',newsku,state)
  
  return newsku[0];  
}

 

const mapDispatchToProps = (dispatch, ownProps) => ({
  onClick: ( () => dispatch(state_update({attr:ownProps.attr,value:ownProps.value})))
 // onClick: () =>state_update({attr:ownProps.attr,value:ownProps.value})
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AiOptionSet)


// WEBPACK FOOTER //
// ./src/layout/AiOptionSetWrap.js